export default __webpack_public_path__ + "static/media/hongjiang_logo.a3b4b627.png";